/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Channel_QuickInputs */

const vi_order_channel_quick = /** @type {(inputs: Order_Channel_QuickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn nhanh`)
};

/**

* @param {Order_Channel_QuickInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_channel_quick = /** @type {((inputs?: Order_Channel_QuickInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Channel_QuickInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_channel_quick(inputs)
});